import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as budgetActions from '../../actions/budgetActions';
import * as mandatoriesActions from '../../actions/mandatoriesActions';
import './mandatories.scss';
import MandatoriesForm from './MandatoriesForm';
import PropTypes from 'prop-types';
import * as utils from '../../utils';

class MandatoriesContainer extends Component {
  constructor(props, context) {
		super(props, context);
		this.state = {
			mandatories: Object.assign({}, this.props.mandatories),
			errors: {},
			activeValidationEnabled: false
		};
		this.updateUserState = this.updateUserState.bind(this);
		this.saveUserState = this.saveUserState.bind(this);
		this.validate = this.validate.bind(this);
		this.toggleStep = this.toggleStep.bind(this);
	}

	toggleStep(event) {
		this.props.openItem(0);
		return false;
	}

	visitedMarker() {
		return (
			<svg width="24" height="24" viewBox="0 0 24 24"><path d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" /></svg>
		)
	}

	validate(user) {
		return {
			company: utils.validString(user.company, 2) ? null : "Please enter at least two characters.",
			associates: utils.validNumAssoc(user.associates) ? null : "Please enter a positive number of Associates",
			contactName: utils.validString(user.contactName, 2) ? null : "Please enter at least two characters.",
			contactEmail: utils.validEmail(user.contactEmail, false) ? null : "Please enter a valid email address.",
			// contactPhone: utils.validString(user.contactPhone, 10) ? null : "Please enter the full 10-digit number.",
      projectSqFt: utils.validSqFt(user.projectSqFt) ? null : "Please enter a positive square footage.",
			projectName: utils.validString(user.projectName, 2) ? null : "Please enter at least two characters.",
			representitiveName: utils.validString(user.representitiveName, 2) ? null : "Please enter at least two characters.",
			representitiveEmail: utils.validEmail(user.representitiveEmail, false) ? null : "Please enter a valid email address.",

		}
	}

	updateUserState(event) {
		const field = event.target.name;
		let user = this.state.mandatories;
		user[field] = event.target.name === 'associates' ? Number(event.target.value)
      : event.target.name === 'projectSqFt' ? Number(event.target.value)
      : event.target.value;
		this.setState({mandatories: user });
	}

	saveUserState(event) {
		event.preventDefault();
		const errors = this.validate(this.state.mandatories)
		this.setState({ errors: errors });
		if (!Object.keys(errors).some(x => errors[x])) {
			// Save and direct to new state!
			this.props.mandatoriesActions.save(this.state.mandatories);
			this.setState({visited: true});
			this.props.nextItem();
		}
	}

	contentWhenOpen() {
		return (
			<div className="content">
					<MandatoriesForm onChange={this.updateUserState}
						user={this.state.mandatories}
						errors={this.state.errors}
						onSave={this.saveUserState} />
				</div>
		)
	}

	render() {
		const { open } = this.props; // Destructure this.props to make coding a bit less error prone.
		return (
			<section className="calculator-step">
				<h4 onClick={this.toggleStep}>
				{this.state.visited && this.visitedMarker()}
				Project Details
				{open === true ? <a className="calculator-step-toggle-close">-</a> : <a className="calculator-step-toggle-open">+</a>}</h4>
				{open && this.contentWhenOpen()}
			</section>
		);
	}
}


MandatoriesContainer.propTypes = {
	openItem: PropTypes.func.isRequired,
	nextItem: PropTypes.func.isRequired,
	open: PropTypes.bool.isRequired
}


const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		actions: bindActionCreators(budgetActions, dispatch),
		mandatoriesActions: bindActionCreators(mandatoriesActions, dispatch)
	};
}

const mapStateToProps = (state, ownProps) => {

	// let mostFavoriteIds = state.user.FavoriteLocations.filter(loc => loc.IsMostFavorite).map(mostFav => mostFav.RestaurantId);
	// let immutableRestaurants = [...state.restaurants].map((restaurant) => {
	// 	return Object.assign({}, restaurant, { IsMostFavorite: mostFavoriteIds.indexOf(restaurant.Id) > -1 });
	// });

	// immutableRestaurants.sort((rA, rB) => {
	// 	let nameA = rA.Title.toUpperCase(); // ignore upper and lowercase
	// 	let nameB = rB.Title.toUpperCase(); // ignore upper and lowercase
	// 	if (rA.IsMostFavorite ^ rB.IsMostFavorite) {
	// 		return rA.IsMostFavorite ? -1 : 1; // mostFavoriteRestaurant should be closer to the beginning of the list
	// 	} else {
	// 		if (nameA < nameB) return -1;
	// 		if (nameA > nameB) return 1;
	// 		return 0;
	// 	}
	// });

	return {
		mandatories: state.mandatories
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(MandatoriesContainer);



// WEBPACK FOOTER //
// ./src/components/mandatories/MandatoriesContainer.js